module.exports = __webpack_public_path__ + "files/3b3ff5619f47bb4d5b3a315e7f8d5645.png";